import styled from 'styled-components'
import React from 'react'

const accordionBarGraphWidth = 240

export const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${ (props) => props.theme.colors.weiss };

  &.accordion-custom-trigger {
    background: transparent;
  }

  .disclaimer-anchor {
    text-decoration: none;
  }

  .bar-graph-wrapper {
    max-width: none;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      width: ${ accordionBarGraphWidth }px;
    }
  }

  .bar-graph-average {
    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      // calc percentage to pixels to set average indicator to total pixels
      // to make sure all indicators have the same width (also at non-retina displays)
      // see https://bugs.onedev.aok.de/browse/MGMPMNAV-1019
    }
  }

  .accordion-bar-graph {
    width: ${ accordionBarGraphWidth }px;
  }

  @media print {
    height: auto !important;
    overflow: visible;
    display: block;
  }
`

export const ToggleTrigger = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 10px 15px;
  cursor: pointer;
  outline: none;

  .h4 {
    margin: 0 15px 0 0;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      align-items: center;
      display: flex;
    }
  }

  .accordion-bar-graph {
    // decrease width with 26px to make sure, that the accordion-toggle-icon
    // is at the same line like the barGraph
    width: calc(100% - 26px);

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      width: ${ accordionBarGraphWidth }px;
    }
  }

  .accordion-icon > svg {
    display: inline-block;
    transform-origin: center center;
    transition: 0.2s;
    margin-left: auto;
    transform: rotate(${ (props) => (props['style-open'] ? '180deg' : '0deg') });

    .accordion-asv & {
      margin-left: 0;
    }
  }

  .accordion-tooltip {
    margin-left: 10px;
  }

  /* modifier definition */
  .accordion-rating & {
    padding: 0 0 20px;
    flex-wrap: wrap;
  }

  .accordion-underlined & {
    padding: 0;
    text-decoration: underline;

    .accordion-icon > svg {
      width: 14px;
      height: 14px;
    }
  }

  .accordion-asv & {
    padding: 14px 0 14px 30px;
    align-items: flex-start;
    //replace later (background color)
    background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
  }

  .accordion-custom-trigger & {
    padding: 0;
    justify-content: space-between;
  }

  .accordion-rating &,
  .accordion-underlined & {
    .accordion-icon {
      margin-left: 10px;
    }
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    align-items: center;
    padding: 30px;
  }
`

export const InfoIconContainer = styled.span`
  margin-left: 10px;
`

export const TriggerLabel = styled(({ tag, children, ...props }) =>
  React.createElement(tag, props, children)
)`
  margin-right: 10px;
  margin-bottom: 10px;
  flex-grow: 1;

  .average-value {
    font-weight: bold;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-bottom: 0;
  }

  .accordion-asv & {
    flex-grow: 0;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  overflow: hidden;
  min-height: 0;
  height: 0;

  @media print {
    height: auto !important;
    overflow: visible;
    display: block;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
`

export const Content = styled.div`
  width: 100%;
`
